import axios from "axios";

export default {
  offers(query) {
    return axios.get("/api/offers", {
      params: query
    });
  },
  schoolingOffers() {
    return axios.get("/api/offers/schooling");
  },
  schoolingOffersList() {
    return axios.get("/api/offers/schooling_list");
  },
  offerCategories(query) {
    return axios.get("/api/offers/categories");
  },
  sessionCategories(query) {
    return axios.get("/api/sessions/categories");
  },
  sessions(query) {
    return axios.get("/api/sessions", {
      params: {
        per_page: query.perPage,
        page: query.page,
        start: query.start,
        end: query.end,
        category: query.category,
        archived: query.archived
      }
    });
  },
  createPromoCode(promoCode) {
    return axios.post('/api/offers/promo_code/add', promoCode);
  },
  updatePromoCode(id, promoCode) {
    return axios.post(`/api/offers/promo_code/update/${id}`, promoCode);
  },
  getPromoCode(id) {
    return axios.get(`/api/offers/promo_code/show/${id}`);
  },
  generatePromoCode(data) {
    return axios.post('/api/offers/promo-code/generate', data);
  },
  checkPromoCodeUnique(data) {
    return axios.post('/api/offers/promo-code/check-unique', data);
  },
  deletePromoCode(id) {
    return axios.post(`/api/offers/promo_code/delete/${id}`);
  },
  archivePromoCode(id) {
    return axios.post(`/api/offers/promo_code/archive/${id}`);
  },
  getPromoCodes(query) {
    return axios.get("/api/offers/promo_codes", {
      params: query
    });
  },
  exportPromoCodeCandidatures(query) {
    return axios
        .get("/api/offers/promo_code/applications/export", {
          responseType: "blob",
          params: query
        })
        .then(function(response) {
          return response;
        });
  },
  exportSessions(query) {
    return axios
        .get("/api/sessions/export", {
          responseType: "blob",
          params: {
            per_page: query.perPage,
            page: query.page,
            start: query.start,
            end: query.end,
            category: query.category,
            archived: query.archived
          }
        })
        .then(function(response) {
          return response;
        });
  },
  filterSessions(filter) {
    return axios
      .get(
        "/api/offers/category/" +
          filter.filters.category +
          "/" +
          filter.filters.school +
          "/filter",
        {
          params: {
            per_page: filter.perPage,
            current_page: filter.currentPage,
            page: filter.page,
            filter: filter.filters
          }
        }
      )
      .catch(error => {
        return error.response;
      });
  },
  sessionsEvents(filter) {
    return axios
      .get("/api/offers/sessions/events/" + filter.category, {
        params: {
          filter: filter
        }
      })
      .catch(error => {
        return error.response;
      });
  },

  offerCategory(categoryId) {
    return axios.get("/api/offers/category/" + categoryId);
  },
  offerSuggests(categoryId, campus) {
    return axios.get("/api/offers/suggests/" + categoryId+ '/'+ campus);
  },
  offerSessions(categoryId, schoolSlug) {
    return axios.get(
      "/api/offers/category/" + categoryId + "/" + schoolSlug + "/sessions"
    );
  },
  offerAdminSessions(categoryId) {
    return axios.get("/api/offers/category/" + categoryId + "/sessions");
  },

  offerRelatedSessions(session) {
    return axios.get("/api/offers/sessions/related/" + session.id, {
      params: {
        price: session.price,
      }
    });
  },

  showOffer(offerId) {
    return axios.get("/api/offer/show/" + offerId);
  },
  adminOffer(offerId) {
    return axios.get("/api/offer/admin/" + offerId);
  },

  addOffer(data) {
    return axios
      .post("/api/offer/create", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  updateOffer(id, data) {
    return axios
        .post("/api/offer/update/" + id, data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  updateOfferSession(data) {
    return axios
        .post("/api/order/session/update", data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  cancelSessionRegistration(data) {
    return axios
        .post("/api/order/session/cancel", data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  deleteOffer(id, data) {
    return axios
        .post("/api/offer/delete/" + id, data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  restoreOffer(id, data) {
    return axios
        .post("/api/offer/restore/" + id, data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  addCategory(data) {
    return axios
        .post("/api/offercategory/create", data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  updateCategory(id, data) {
    return axios
        .post("/api/offercategory/update/" + id, data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  deleteCategory(id, data) {
    return axios
        .post("/api/offercategory/delete/" + id, data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  deleteCategoryTheme(data) {
    return axios.post("/api/offercategorytheme/delete", data);
  },
  deleteMedia(id, data) {
    return axios
      .post("/api/offer/media/delete/" + id, data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  deleteSession(id, data) {
    return axios
      .post("/api/offer/session/delete/" + id, data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  updateSession(id, data) {
    return axios
      .post("/api/offer/session/update/" + id, data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  addChoiceToCart(data) {
    return axios
      .post("/api/order/add/choice", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  saveChoice(data) {
    return axios
      .post("/api/order/save/choice", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  restoreChoice(data) {
    return axios
      .post("/api/order/restore/choice", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  removeChoiceFromCart(data) {
    return axios
      .post("/api/order/remove/choice", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  removeSessionChoiceFromCart(data) {
    return axios
      .post("/api/order/remove/session_choice", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  getOrder(orderId) {
    return axios.get("/api/order/" + orderId);
  },
  pendingOrder(userId) {
    return axios.get("/api/order/pending/" + userId);
  },
  checkedoutOrders(userId) {
    return axios.get("/api/orders/checkedout/" + userId);
  },
  completeOrders(userId) {
    return axios.get("/api/orders/complete/" + userId);
  },
  canceledOrders(userId) {
    return axios.get("/api/orders/canceled/" + userId);
  },
  savedOrderItems(candidateId) {
    return axios.get("/api/order/items/saved/" + candidateId);
  },
  saveOrderPayments(data) {
    return axios
      .post("/api/order/payments/save", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  saveTotalCheckout(data) {
    return axios
      .post("/api/order/checkout/edit", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  orderCheckout(data) {
    return axios
      .post("/api/order/checkout", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  fetchCBCheckout(order) {
    return axios
      .get("/api/order/payment/checkout", {
        params: { order_id: order.order_id, credit: order.credit, discount: order.discount }
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  orderComplete(data) {
    return axios
      .post("/api/order/complete", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  orderDelete(data) {
    return axios
      .post("/api/order/delete", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  orderCancel(data) {
    return axios
        .post("/api/order/cancel", data)
        .then(response => {
          return response;
        })
        .catch(error => {
          return error.response;
        });
  },
  confirmOrderPayment(data) {
    return axios
      .post("/api/order/ofp/accepted", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  sendMessage(message) {
    return axios
      .post("/api/candidate/shop/message", message)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  fetchMessages(id) {
    return axios
      .get("/api/candidate/shop/messages/" + id)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  }
};
